import React from 'react';
const benefits = [{
  icon: '🏉',
  tag: 'Contenido Técnico',
  title: '6 Tomos de Élite',
  desc: 'Unidades de aprendizaje progresivas, cubriendo todas las edades y niveles desde Iniciación hasta Juveniles.',
  accent: 'rgba(59,130,246,0.5)',
  glow: 'rgba(59,130,246,0.25)',
  bgGradient: 'from-blue-500/15 to-blue-600/0',
  iconBg: 'bg-blue-500/15',
  iconBorder: 'border-blue-500/30',
  textColor: 'text-blue-400'
}, {
  icon: '🛡️',
  tag: 'Seguridad',
  title: 'Protocolos de Contacto',
  desc: 'Guía técnica paso a paso para enseñar Tackle y Ruck minimizando riesgos de lesión.',
  accent: 'rgba(34,197,94,0.5)',
  glow: 'rgba(34,197,94,0.25)',
  bgGradient: 'from-green-500/15 to-green-600/0',
  iconBg: 'bg-green-500/15',
  iconBorder: 'border-green-500/30',
  textColor: 'text-green-400'
}, {
  icon: '🧠',
  tag: 'Estrategia',
  title: 'Inteligencia Táctica',
  desc: 'Lectura de juego, sistema de Pods, estructuras de ataque y defensa presionante.',
  accent: 'rgba(168,85,247,0.5)',
  glow: 'rgba(168,85,247,0.25)',
  bgGradient: 'from-purple-500/15 to-purple-600/0',
  iconBg: 'bg-purple-500/15',
  iconBorder: 'border-purple-500/30',
  textColor: 'text-purple-400'
}, {
  icon: '📈',
  tag: 'Liderazgo',
  title: 'Gestión y Liderazgo',
  desc: 'Cómo organizar el Staff, manejar la psicología del grupo y medir el progreso de tus jugadores.',
  accent: 'rgba(245,158,11,0.5)',
  glow: 'rgba(245,158,11,0.25)',
  bgGradient: 'from-secondary/20 to-secondary/0',
  iconBg: 'bg-secondary/15',
  iconBorder: 'border-secondary/30',
  textColor: 'text-secondary'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 sm:py-28 px-4 relative overflow-hidden" data-id="element-1">
      {/* Decorative background glows */}
      <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-primary/8 rounded-full blur-[120px] pointer-events-none" data-id="element-2"></div>
      <div className="absolute bottom-0 right-0 w-[450px] h-[450px] bg-secondary/8 rounded-full blur-[120px] pointer-events-none" data-id="element-3"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-4">
        {/* Eyebrow with decorative lines */}
        <div className="flex items-center justify-center gap-3 mb-5" data-id="element-5">
          <span className="h-px w-8 sm:w-12 bg-gradient-to-r from-transparent to-primary/60" data-id="element-6"></span>
          <p className="text-primary font-bold text-sm sm:text-base tracking-[0.2em] uppercase whitespace-nowrap" data-id="element-7">
            🎁 Qué hay dentro
          </p>
          <span className="h-px w-8 sm:w-12 bg-gradient-to-l from-transparent to-primary/60" data-id="element-8"></span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-5 text-center tracking-tight leading-tight max-w-3xl mx-auto" data-id="element-9">
          Todo lo que un entrenador necesita en{' '}
          <span className="relative inline-block" data-id="element-10">
            <span className="relative z-10 text-primary" data-id="element-11">un único lugar</span>
            <span className="absolute bottom-1 left-0 right-0 h-2 sm:h-3 bg-primary/20 -z-0 rounded-sm" data-id="element-12"></span>
          </span>
        </h2>
        <p className="text-text-sec text-base sm:text-xl max-w-2xl mx-auto text-center mb-14 sm:mb-16" data-id="element-13">
          Cuatro pilares estratégicos diseñados para que dejes de improvisar y
          entrenes con confianza.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-7" data-id="element-14">
          {benefits.map((benefit, i) => {
          const num = String(i + 1).padStart(2, '0');
          return <div key={i} className="group relative bg-bg-alt/80 backdrop-blur-sm p-7 sm:p-8 rounded-3xl border border-border-light shadow-xl flex flex-col gap-4 transition-all duration-500 hover:-translate-y-1.5 overflow-hidden" style={{
            transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = benefit.accent;
            e.currentTarget.style.boxShadow = `0 20px 50px -10px ${benefit.glow}`;
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = '';
            e.currentTarget.style.boxShadow = '';
          }} data-id="element-15">
                {/* Top accent line */}
                <span className="absolute top-0 left-0 right-0 h-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
              background: `linear-gradient(90deg, transparent, ${benefit.accent}, transparent)`
            }} data-id="element-16"></span>

                {/* Subtle gradient overlay on hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${benefit.bgGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`} data-id="element-17"></div>

                {/* Number watermark */}
                <span className={`absolute top-5 right-6 sm:top-6 sm:right-8 text-5xl sm:text-6xl font-black ${benefit.textColor} opacity-10 group-hover:opacity-20 transition-opacity duration-500 select-none pointer-events-none leading-none`} data-id="element-18">
                  {num}
                </span>

                {/* Header row: icon + tag */}
                <div className="flex items-center gap-3 relative z-10" data-id="element-19">
                  <div className={`w-14 h-14 sm:w-16 sm:h-16 rounded-2xl ${benefit.iconBg} border ${benefit.iconBorder} flex items-center justify-center text-3xl sm:text-4xl shadow-inner group-hover:scale-110 transition-transform duration-500`} data-id="element-20">
                    {benefit.icon}
                  </div>
                  <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-[0.15em] ${benefit.textColor} px-2.5 py-1 rounded-full ${benefit.iconBg} border ${benefit.iconBorder}`} data-id="element-21">
                    {benefit.tag}
                  </span>
                </div>

                <h3 className="text-xl sm:text-2xl font-black text-text-main relative z-10 tracking-tight mt-1" data-id="element-22">
                  {benefit.title}
                </h3>
                <p className="text-text-sec leading-relaxed text-base sm:text-lg relative z-10" data-id="element-23">
                  {benefit.desc}
                </p>
              </div>;
        })}
        </div>

        {/* Bottom reinforcement */}
        <p className="text-center text-text-sec text-sm sm:text-base mt-10 sm:mt-14 max-w-2xl mx-auto" data-id="element-24">
          <span className="text-text-main font-bold" data-id="element-25">+ acceso inmediato</span> a
          todos los recursos en formato digital, listos para imprimir o usar
          desde tu móvil al borde del campo.
        </p>
      </div>
    </section>;
}